import Navbar from './components/navbar/Navbar';
import Footer from './components/footer/Footer';
import './App.css';
import Home from './pages/home/home';
import MainRoutes from "./routes";
import useIsInIframe from './hooks/useIsInIframe';


function App() {
  const isInIframe = useIsInIframe();
  
  return (
    <div className="page-container">
      {!isInIframe && <Navbar />}
      <div className="app">
        <div className="section">
          <Home/>
        </div>
      </div>
      {!isInIframe && <Footer />}
    </div>
  );
}

export default App;
